<template>
    <a-cascader
        :get-popup-container="getPopupContainer"
        placeholder="请选择"
        :change-on-select="changeOnSelect"
        :value="valueArray"
        :options="areaTreeList"
        :field-names="fieldNames"
        @update:value="onUpdateValue"
        style="width: 100%"
        :allowClear="false"
    />
</template>

<script>
import {computed, onMounted, ref} from "vue";
// import {areaTreeList} from "@/utils/areaData";
import {area} from "@/api/areaApi";
import {getAction} from "@/utils/http/service";
import {convertTreeData} from "@/utils/convertData";

export default {
    name: "AllCitySelect",
    emits: [
        "update:value",
        "update:prov",
        "update:city",
        "update:dist",
        "update:last",
    ],
    props: {
        areaIds: {
            type: String,
            default: "",
        },
        prov: {
            type: String,
            default: "",
        },
        city: {
            type: String,
            default: "",
        },
        dist: {
            type: String,
            default: "",
        },
        fieldNames: {
            type: Object,
            default() {
                return {
                    label: "title",
                    value: "value",
                    children: "children",
                };
            },
        },
        changeOnSelect: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, {emit}) {
        const areaTreeList = ref([])

        onMounted(() => {
            // 加载地区数据
            getAction({url :area.list}).then(data => {
                console.log(data,'data')
                let treeData = convertTreeData({
                    datas: data,
                    rootValue: "",
                    valueField: 'areaId',
                    titleField: 'areaName',
                    parentField: 'superId'
                })
                areaTreeList.value = treeData
            })
        })
        const valueArray = computed(() => {
            if (props.areaIds) {
                return props.areaIds.split(',')
            }
            if (!props.prov) {
                return [];
            } else {
                return [props.prov, props.city, props.dist];
            }
        });
        console.log(valueArray,'valueArray')
        const onUpdateValue = (value) => {
            console.log(value,'value')
            let length = (value || []).length
            emit("update:value", value);
            emit("update:areaIds", (value || []).join(','));
            if(length >= 1) {
                emit("update:prov", value[0]);
                emit("update:last", value[length-1]);
            } else {
                emit("update:last", "");
            }
            if(length >=2) {
                console.log(111)
                emit("update:city", value[1]);
            }
            if(length >=3) {
                console.log(222)

                emit("update:dist", value[2]);
            }
        };
        return {
            areaTreeList,
            valueArray,
            onUpdateValue,
        };
    },
};
</script>

<style scoped>
</style>
